import setIsLoading from "reducers/lockingSystemReducer/utils/setIsLoading"
import { getSelectedConfigurationsAfterSystemChange } from "@secureo/common/reducers/productDetailPageReducer"
import getCylinderConfigurationVariantSku from "@secureo/common/reducers/productDetailPageReducer/utils/getCylinderConfigurationVariantSku"
import fetchCylinderConfigurationVariant from "@secureo/common/utils/commerceTools/graphql/queries/fetchCylinderConfigurationVariant"
import { setComponentCylinderConfigurationVariant } from "./setComponentCylinderConfigurationVariant"

import {
	LockingSystemReducerState,
	DispatchLockingSystemReducer,
} from "reducers/lockingSystemReducer"
import { ProviderContext } from "notistack"

export const setSelectedComponentSystem = async (
	accessToken: string,
	reducerState: LockingSystemReducerState,
	dispatch: DispatchLockingSystemReducer,
	uuid: string,
	selectedSystem: string,
	enqueueSnackbar: ProviderContext["enqueueSnackbar"],
) => {
	const { locale } = reducerState

	const component = reducerState.componentsByUuid[uuid]

	setIsLoading(dispatch, true)

	const { cylinderConfigurationType, attributes, variantsByVariantId } = component

	const { selectedOuterLength, selectedInnerLength } = getSelectedConfigurationsAfterSystemChange(
		cylinderConfigurationType,
		attributes,
		selectedSystem,
		component.selectedOuterLength,
		component.selectedInnerLength,
	)

	dispatch({
		type: "SET_COMPONENT_CONFIGURATIONS",
		payload: {
			uuid,
			selectedSystem,
			selectedOuterLength,
			selectedInnerLength,
		},
	})

	const componentWithUpdatedSelectedConfigurations = {
		...component,
		selectedSystem,
		selectedOuterLength,
		selectedInnerLength,
	}

	const cylinderConfigurationVariantSku = getCylinderConfigurationVariantSku(
		cylinderConfigurationType,
		attributes,
		variantsByVariantId,
		selectedSystem,
		selectedOuterLength,
		selectedInnerLength,
	)
	const cylinderConfigurationVariant = await fetchCylinderConfigurationVariant(
		accessToken,
		cylinderConfigurationVariantSku,
		locale,
	)

	setComponentCylinderConfigurationVariant(
		dispatch,
		reducerState,
		componentWithUpdatedSelectedConfigurations,
		cylinderConfigurationVariant,
		enqueueSnackbar,
	)

	setIsLoading(dispatch, false)
}
